import { Image as MjImage } from "@mijadesign/mjui-react";
import "@mijadesign/mjui-react/dist/esm/Image/style/css";
import type { ComponentProps } from "react";

const DEFAULT_IMAGE_SOURCE = "https://placehold.co/300x200?text=Image";
const DEFAULT_IMAGE_WIDTH = "100%";
const DEFAULT_IMAGE_HEIGHT = "auto";

type H5ImageProps = ComponentProps<typeof MjImage>;

function H5Image({
  src = DEFAULT_IMAGE_SOURCE,
  width = DEFAULT_IMAGE_WIDTH,
  height = DEFAULT_IMAGE_HEIGHT,
  fit = "cover",
  position = "center",
  alt = "",
  radius = 0,
  lazy = false,
  ...rest
}: H5ImageProps) {
  return (
    <MjImage
      src={src}
      width={width}
      height={height}
      fit={fit}
      position={position}
      alt={alt}
      radius={radius}
      lazy={lazy}
      {...rest}
    />
  );
}

export default H5Image;
